jQuery(document).ready(function ($) {

    $('#toggleMenu').click(function (){
        let navigation = $('#top-navigation');
        let toggleSearch = $('#toggleSearch');
        navigation.find('.mobile-menu').toggleClass('show');
        navigation.find('.mobile-search').removeClass('show');
        toggleSearch.find('.close-icon').addClass('d-none');
        toggleSearch.find('.search-icon').removeClass('d-none');
        if (navigation.find('.mobile-menu').hasClass('show')) {
            $(this).find('.burger-icon').addClass('d-none');
            $(this).find('.close-icon').removeClass('d-none');
        } else {
            $(this).find('.close-icon').addClass('d-none');
            $(this).find('.burger-icon').removeClass('d-none');
        }
    });


});